<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">
        <div class="row header-row">
            <div class="col-md-6">
                <div class="title-wrapper">
                    <h1 class="title-default">Configuração Emissores</h1>
                    <p class="welcome-message">
                        <button mat-icon-button (click)="voltar()">
                            <mat-icon>arrow_back</mat-icon>
                        </button>
                        Gerenciamento de emissores de documentos fiscais
                    </p>
                </div>
            </div>
            <div class="col-md-6 header-actions">
                <a type="button" mat-flat-button class="btn-primary"
                    routerLink="/configuracoes/notas-fiscais/emissor/cadastrar">
                    <mat-icon>add</mat-icon>
                    Novo emissor
                </a>
            </div>
        </div>
        <form class="form" [formGroup]="model" (ngSubmit)="clickPesquisar()" class="search-area">
            <div class="row">
                <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Pesquisar</mat-label>
                        <input matInput formControlName="pesquisa" type="text" placeholder="Pesquisar por nome">
                        <button mat-icon-button matSuffix type="button" (click)="clickPesquisar()"
                            aria-label="Pesquisar">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-6 filter-container">
                    <button mat-stroked-button type="button" class="btn-filter" (click)="configurarColunas()">
                        <mat-icon>view_column</mat-icon>
                        Configurar Colunas
                    </button>
                </div>
            </div>
        </form>

        @if (possuiEmissorPadrao === false) {
        <app-alert-card class="d-block mb-3" type="warning" title="Nenhum emissor padrão para NF-e">
            Marque um emissor ativo, com a emissão de NF-e ativa, como padrão para NF-e. Ele é usado quando a
            natureza de operação não informa um emissor.
        </app-alert-card>
        }

        @if(this.listaEmissoresResponse && this.listaEmissoresResponse.listaEmissorStruct.length > 0){
        <div class="desktop-view table-responsive">
        <table mat-table class="w-100" [dataSource]="_dataSource" matSort>

            <ng-container matColumnDef="nome">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nome </th>
                <td mat-cell *matCellDef="let element">
                    <div class="d-flex align-items-center flex-wrap gap-2">
                        <span>{{element.nome}}</span>
                        @if(element.emiteNFCe){
                        <span class="status-badge badge-azul">NFC-e</span>
                        }
                        @if(element.emiteNFe){
                        <span class="status-badge badge-verde">NF-e</span>
                        }
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="token">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Token </th>
                <td mat-cell *matCellDef="let element">
                    <span class="token-selectable" (click)="selecionarToken($event)">{{element.token}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="serieSequencialNFCe">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Sequencial/Série NFC-e </th>
                <td mat-cell *matCellDef="let element" [class.text-line-through]="!element.emiteNFCe">
                    {{element.serieSequencialNFCe}} </td>
            </ng-container>

            <ng-container matColumnDef="serieSequencialNFe">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Sequencial/Série NF-e </th>
                <td mat-cell *matCellDef="let element" [class.text-line-through]="!element.emiteNFe">
                    {{element.serieSequencialNFe}} </td>
            </ng-container>

            <ng-container matColumnDef="tipoAmbiente">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Tipo ambiente</th>
                <td mat-cell *matCellDef="let element" class="text-center">
                    @if(element.isTipoAmbienteAutomatico){
                    <div class="status-badge badge-azul" matTooltip="Acompanha o ambiente definido nas configurações gerais do sistema.">
                        Automático ({{ element.idTipoAmbiente === TipoAmbienteEnum.Producao ? 'Produção' : 'Homologação' }})
                    </div>
                    } @else if(element.idTipoAmbiente === TipoAmbienteEnum.Producao){
                    <div class="status-badge badge-verde">Produção</div>
                    } @else if(element.idTipoAmbiente === TipoAmbienteEnum.Homologacao){
                    <div class="status-badge badge-cinza">Homologação</div>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="padrao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="isPadraoNFe" class="text-center">Padrão</th>
                <td mat-cell *matCellDef="let element" class="text-center">
                    @if(element.isPadraoNFe){
                    <span class="status-badge badge-roxo">Padrão NF-e</span>
                    } @else {
                    <span>-</span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="ativo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center"> Status </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                    @if(element.ativo){
                    <div class="status-badge badge-verde ">
                        Ativo
                    </div>
                    } @else{
                    <div class="status-badge badge-cinza ">
                        Inativo
                    </div>
                    }

                </td>
            </ng-container>



            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                <td mat-cell *matCellDef="let element" class="text-center w-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/notas-fiscais/emissor/cadastrar', {idEmissor: element.idEmissor}]">
                            <span class="material-symbols-outlined">edit</span>
                            <span>Editar</span>
                        </button>
                        <span [matTooltip]="motivoDefinirPadraoIndisponivel(element) ?? ''"
                            [matTooltipDisabled]="!motivoDefinirPadraoIndisponivel(element)">
                            <button mat-menu-item [disabled]="!!motivoDefinirPadraoIndisponivel(element)"
                                (click)="definirPadraoNFe(element)">
                                <span class="material-symbols-outlined">star</span>
                                <span>Definir padrão NF-e</span>
                            </button>
                        </span>
                        <span [matTooltip]="tooltipSemPermissaoExcluir" [matTooltipDisabled]="podeExcluir">
                        <button mat-menu-item [disabled]="!podeExcluir" (click)="abrirModalExcluir(element)">
                            <span class="material-symbols-outlined">delete</span>
                            <span>Excluir</span>
                        </button>
                        </span>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        </div>

        <div class="mobile-view">
            @for (element of _dataSource.data; track element.idEmissor) {
            <div class="card-mobile mb-3">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center flex-wrap gap-2">
                        <strong class="text-bold">{{element.nome}}</strong>
                        @if(element.emiteNFCe){
                        <span class="status-badge badge-azul">NFC-e</span>
                        }
                        @if(element.emiteNFe){
                        <span class="status-badge badge-verde">NF-e</span>
                        }
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="menuMobile" aria-label="Ações">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menuMobile="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/notas-fiscais/emissor/cadastrar', {idEmissor: element.idEmissor}]">
                            <span class="material-symbols-outlined">edit</span>
                            <span>Editar</span>
                        </button>
                        <span [matTooltip]="motivoDefinirPadraoIndisponivel(element) ?? ''"
                            [matTooltipDisabled]="!motivoDefinirPadraoIndisponivel(element)">
                            <button mat-menu-item [disabled]="!!motivoDefinirPadraoIndisponivel(element)"
                                (click)="definirPadraoNFe(element)">
                                <span class="material-symbols-outlined">star</span>
                                <span>Definir padrão NF-e</span>
                            </button>
                        </span>
                        <span [matTooltip]="tooltipSemPermissaoExcluir" [matTooltipDisabled]="podeExcluir">
                        <button mat-menu-item [disabled]="!podeExcluir" (click)="abrirModalExcluir(element)">
                            <span class="material-symbols-outlined">delete</span>
                            <span>Excluir</span>
                        </button>
                        </span>
                    </mat-menu>
                </div>
                <div class="card-body-mobile p-3">
                    <p class="mb-1">
                        <strong>Token:</strong>
                        <span class="token-selectable ms-1" (click)="selecionarToken($event)">{{element.token}}</span>
                    </p>
                    <p class="mb-1" [class.text-line-through]="!element.emiteNFCe">
                        <strong>Seq./Série NFC-e:</strong>
                        <span class="ms-1">{{element.serieSequencialNFCe || '-'}}</span>
                    </p>
                    <p class="mb-1" [class.text-line-through]="!element.emiteNFe">
                        <strong>Seq./Série NF-e:</strong>
                        <span class="ms-1">{{element.serieSequencialNFe || '-'}}</span>
                    </p>
                    <p class="mb-1">
                        <strong>Tipo ambiente:</strong>
                        @if(element.isTipoAmbienteAutomatico){
                        <span class="status-badge badge-azul ms-1" matTooltip="Acompanha o ambiente definido nas configurações gerais do sistema.">Automático ({{ element.idTipoAmbiente === TipoAmbienteEnum.Producao ? 'Produção' : 'Homologação' }})</span>
                        } @else if(element.idTipoAmbiente === TipoAmbienteEnum.Producao){
                        <span class="status-badge badge-verde ms-1">Produção</span>
                        } @else if(element.idTipoAmbiente === TipoAmbienteEnum.Homologacao){
                        <span class="status-badge badge-cinza ms-1">Homologação</span>
                        }
                    </p>
                    <p class="mb-1">
                        <strong>Padrão:</strong>
                        @if(element.isPadraoNFe){
                        <span class="status-badge badge-roxo ms-1">Padrão NF-e</span>
                        } @else {
                        <span class="ms-1">-</span>
                        }
                    </p>
                    <p class="mb-0">
                        <strong>Status:</strong>
                        @if(element.ativo){
                        <span class="status-badge badge-verde ms-1">Ativo</span>
                        } @else {
                        <span class="status-badge badge-cinza ms-1">Inativo</span>
                        }
                    </p>
                </div>
            </div>
            }
        </div>

        <div class="col-12 text-center ver-mais-pesquisa">
            <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
                @if (_isLoading === true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
                @else{
                <span class="material-symbols-outlined">keyboard_arrow_down</span>
                Ver mais
                }
            </button>
        </div>
        } @else if(_isLoading) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else {
        <app-empty-list [title]="'Nenhum emissor encontrado'"></app-empty-list>
        }

    </div>
</div>
